import { useRef, useCallback, cloneElement } from 'react';
import { useClickOutside } from '../../hooks/useClickOutside.js';

function useBaseDatePicker({ startOpen, customInput, onCalendarOpen, onCalendarClose, }) {
    const { ref, isComponentVisible: isOpen, toggleComponentVisibility: toggleIsOpen, setIsComponentVisible: setIsOpen, } = useClickOutside(startOpen !== null && startOpen !== void 0 ? startOpen : false);
    const inputRef = useRef(null);
    const handleOpenCalendar = useCallback(() => {
        setIsOpen(true);
        onCalendarOpen === null || onCalendarOpen === void 0 ? void 0 : onCalendarOpen();
    }, [setIsOpen, onCalendarOpen]);
    const handleCloseCalendar = useCallback(() => {
        setIsOpen(false);
        onCalendarClose === null || onCalendarClose === void 0 ? void 0 : onCalendarClose();
    }, [setIsOpen, onCalendarClose]);
    const handleToggleCalendar = useCallback(() => {
        var _a;
        toggleIsOpen();
        if (!isOpen) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen, toggleIsOpen]);
    const inputComponent = cloneElement(customInput, Object.assign(Object.assign({}, customInput.props), { onClickIcon: handleToggleCalendar, inputRef }));
    return {
        ref,
        isOpen,
        handleCloseCalendar,
        handleOpenCalendar,
        inputComponent,
    };
}

export { useBaseDatePicker };
//# sourceMappingURL=useBaseDatePicker.js.map
